// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-account-username_change',
    // #endregion
    // #region Mixins
    mixins: [host.mixins.modal],
    // #endregion
    // #region Properties
    props: {},
    computed: {
        currentUser() {
            return this.$host.store.get("session").currentUser;
        },
        form() {
            return this.$refs?.frmMain?.$form;
        }
    },
    // #endregion
    // #region Data
    data: () => ({
        _userId: '',
        _oldUserName: '',
        _newUserName: '',
        _code: '',
        _errorMessage: '',
        _step: 1,
        _isLoading: false,
    }),
    // #endregion
    // #region Boostrap
    created() {
        this._userId = this.currentUser?.userId;
        this._oldUserName = this.currentUser?.userName;
    },
    // #endregion
    // #region Methods
    methods: {
        async onNext() {
            // #region Set
            this._errorMessage = '';
            this._isLoading = true;
            // #endregion
            // #region Step 1 => 2
            if (this._step === 1) {
                if (!this.form.validate()) {
                    this._isLoading = false;
                    return;
                }
                try {
                    //Run
                    await host.api.get('identity/profile/' + this._userId + '/change/username', { params: { oldUserName: this._oldUserName, newUserName: this._newUserName } });
                    //Set
                    this._step = this._step + 1;
                }
                catch (e) {
                    this._errorMessage = utils.getAxiosErrorMessage(e);
                }
            }
            // #endregion
            // #region Step 2 => 3
            else if (this._step === 2) {
                if (!this.form.validate()) {
                    this._isLoading = false;
                    return;
                }
                try {
                    //Run
                    await host.api.post('identity/profile/' + this._userId + '/change/username', null, { params: { oldUserName: this._oldUserName, newUserName: this._newUserName, code: this._code } });
                    //Set
                    this.$host.login.connect();
                    this.currentWindow.close(1);
                }
                catch (e) {
                    this._errorMessage = utils.getAxiosErrorMessage(e);
                }
            }
            // #endregion
            // #region Finish
            this._isLoading = false;
            // #endregion
        },
        onBack() {
            // #region Set
            this._errorMessage = '';
            // #endregion
            // #regin Run
            this._step = this._step - 1;
            // #endregion
        }
    }
    // #endregion
});
// #endregion
